import { config } from "@noted/configuration";

export const LogoutApi = {
  logout(tokenPromise: Promise<string | undefined>) {
    return {
      mutationFn: async () => {
        const token = await tokenPromise;

        return fetch(`${config.apiUrl}/api/v1/sessions`, {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
      },
    };
  },
};
